import BaseModel from './base.model';
import ClaimPartDetails from './ClaimPartDetails.model';

class ClaimStatusModel extends BaseModel {
  public claimNo: string = '';
  public claimType: string = '';
  public claimSubmitted: string = '';
  public claimOriInvNo: string = '';
  public claimSource: string = '';
  public claimStatus: string = '';
  public cRejectReason: string = '';

  public csPartDetails: ClaimPartDetails[] = [];
}

export default ClaimStatusModel;
